import React from "react";

export default function MSAccess_Val() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Val</h1>
      <p>This is the MSAccess_Val component generated from the SQL JSON.</p>
    </div>
  );
}
